import { observer } from "mobx-react";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import { CONDITION_OPERATORS } from "../../../../../../../policy-types";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { ICompareValueTypeComponentProps } from "../condition-field";
import KeyValueCompareValueStore from "../../../../../../../stores/compare-value/key-value-compare-value-store";
import { TEXTAREA_VARIANTS, Textarea } from "../../../../../../../../../components/inputs/textarea/textarea";

const KeyValueCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: KeyValueCompareValueStore = store as KeyValueCompareValueStore;

    const showValueField = ![CONDITION_OPERATORS.OP_IS_EMPTY, CONDITION_OPERATORS.OP_HAS_ANY_VALUE].includes(condition.operator as CONDITION_OPERATORS);

    return (
        <>
            <FontBody2>
                with a key of
            </FontBody2>
            <Input disabled={!condition.isEditMode} value={compareValueStore.key} onChange={(v) => compareValueStore.setKey(v as string)} placeholder="Type a key name" />
            <FontBody2>
                and a value that
            </FontBody2>

            {operatorSelector}

            {showValueField && <Textarea disabled={!condition.isEditMode} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v as string)} variant={TEXTAREA_VARIANTS.FIT_CONTENT} placeholder={condition.placeholder} />}
        </>
    );
});

export default KeyValueCompareValueField;